export const JOBSEEK_SERVICE_URL: string =
  process.env.NEXT_PUBLIC_LOAD_CONFIG || ' ';
export const ABS_URL: string =
  process.env.NEXT_PUBLIC_LOAD_CONFIG || 'https://www.hirist.tech';
export const AD_SERVICE_URL: string = process.env.NEXT_PUBLIC_API_ADS || '';
export const DOMAIN_NAME: string = process.env.NEXT_PUBLIC_DOMAIN || '';
export const s3Url: string =
  process.env.S3URL || 'https://staticlogo.hirist.com';
